import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const HeaderRow = styled.div`
  margin: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const InfoBox = styled.div`
  background: rgba(12, 116, 136, 0.1);
  border: 1px solid rgba(12, 116, 136, 0.3);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0 15px 0;
  font-size: 12px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  line-height: 1.6;
`;

export const AddButton = styled.button`
  padding: 10px 20px;
  border-radius: 100px;
  border: none;
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const SectionCard = styled.div`
  margin: 15px;
  border-radius: 20px;
  padding: 20px;
  background-color: ${theme.colors.darkBlue};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${theme.font.poppins};
  font-size: 13px;
  margin-bottom: 12px;

  th, td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  th {
    font-weight: 500;
    color: ${theme.colors.white};
    font-size: 11px;
    text-transform: uppercase;
  }

  td {
    color: ${theme.colors.white};
  }

  code {
    background: rgba(255, 255, 255, 0.08);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: ${theme.colors.lightBlue};
  }
`;

export const Badge = styled.span<{ $active: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: ${(p) => (p.$active ? "rgba(76, 175, 80, 0.15)" : "rgba(255, 87, 87, 0.15)")};
  color: ${(p) => (p.$active ? "#4caf50" : "#eb5757")};
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  cursor: pointer;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    inset: 0;
    border-radius: 22px;
    background: ${theme.colors.gray800};
    transition: background 0.2s;

    &::before {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: ${theme.colors.white};
      top: 3px;
      left: 3px;
      transition: transform 0.2s;
    }
  }

  input:checked + span {
    background: #4caf50;

    &::before {
      transform: translateX(18px);
    }
  }
`;

export const ActionButton = styled.button<{ $variant?: "edit" | "delete" }>`
  padding: 6px 12px;
  border-radius: 100px;
  border: 1px solid ${(p) => (p.$variant === "delete" ? "#eb5757" : theme.colors.gray800)};
  background: transparent;
  color: ${(p) => (p.$variant === "delete" ? "#eb5757" : theme.colors.white)};
  font-family: ${theme.font.poppins};
  font-size: 12px;
  cursor: pointer;
  margin-right: 6px;
  white-space: nowrap;

  &:hover {
    border-color: ${(p) => (p.$variant === "delete" ? "#eb5757" : theme.colors.primary)};
    color: ${(p) => (p.$variant === "delete" ? "#eb5757" : theme.colors.primary)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingText = styled.p`
  font-size: 13px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  text-align: center;
  padding: 20px;
`;

export const ConditionBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 11px;
  background: rgba(255, 255, 255, 0.08);
  color: ${theme.colors.lightBlue};
  margin-right: 4px;
  margin-bottom: 2px;
`;

// --- Modal Styles ---

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: ${theme.colors.blue900};
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  width: 100%;
  max-width: 640px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 28px;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
    border-radius: 4px;
  }
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 0 0 20px 0;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const FormLabel = styled.label`
  display: block;
  font-family: ${theme.font.poppins};
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.lightBlue};
  margin-bottom: 6px;
`;

export const FormInput = styled.input<{ $error?: boolean }>`
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid ${(p) => (p.$error ? "#eb5757" : "rgba(255, 255, 255, 0.1)")};
  background: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${(p) => (p.$error ? "#eb5757" : theme.colors.primary)};
  }
`;

export const FormTextarea = styled.textarea<{ $error?: boolean }>`
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid ${(p) => (p.$error ? "#eb5757" : "rgba(255, 255, 255, 0.1)")};
  background: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  resize: vertical;
  min-height: 60px;
  box-sizing: border-box;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${(p) => (p.$error ? "#eb5757" : theme.colors.primary)};
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${theme.colors.primary};
  }

  option {
    background: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormError = styled.span`
  display: block;
  font-family: ${theme.font.poppins};
  font-size: 11px;
  color: #eb5757;
  margin-top: 4px;
`;

export const ConditionEditorWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.15);
`;

export const ConditionRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RemoveConditionButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #eb5757;
  background: transparent;
  color: #eb5757;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: rgba(235, 87, 87, 0.1);
  }
`;

export const AddConditionButton = styled.button`
  padding: 6px 14px;
  border-radius: 100px;
  border: 1px dashed ${theme.colors.gray800};
  background: transparent;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  font-size: 12px;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

export const ModalButton = styled.button<{ $primary?: boolean }>`
  padding: 10px 24px;
  border-radius: 100px;
  border: 1px solid ${(p) => (p.$primary ? theme.colors.primary : theme.colors.gray800)};
  background: ${(p) => (p.$primary ? theme.colors.primary : "transparent")};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ValidationHint = styled.span<{ $valid: boolean }>`
  font-family: ${theme.font.poppins};
  font-size: 11px;
  color: ${(p) => (p.$valid ? "#4caf50" : "#eb5757")};
  margin-top: 4px;
  display: block;
`;
